__turbopack_context__.v({
  "modal": "BoxPickupScheduleOrderModal-module-scss-module__73sYca__modal",
});
